<template>
<div class="chapter">
<div class="inner_page">
<section aria-labelledby="ack" epub:type="acknowledgments" role="doc-acknowledgments">
<header>
<h1 class="fmh" id="ack"><span href="#/xhtml/contents#c_ack" title="Link target outside of Sample"><b><i>acknowledgments</i></b></span></h1>
</header>
<p class="co">As always, I like to thank the people who are on this journey with me. First and greatest is my mother, Veronica Reid, for her patience, thoughtfulness, and caring ways. You have helped me keep my focus and motivation. I love you.</p>
<p class="stni">For my sister Arlene, you are almost in your last year of college, girl. Go get it!</p>
<p class="stni">My grandmother, Pastor Phyllis Brown, a leader in the community, has always been an inspiration of strength to me.</p>
<p class="stni">To Lucy, Matilda, Marisol, and Anthony, you all hold special places in my heart with Mami and Papi. I will never forget the life we shared for many years.</p>
<p class="stni">To my best friend, Willie James Clark, may God continue to bless and prosper you and yours. Every woman needs a strong man like you to hold ’em down. You are keeping the seat warm for my man, and he’s got big shoes to fill! For Latoya, Nicole, Carline, and all the women out there trying to make things happen!</p>
<p class="stni">A cute two-snap to the girls at the New York Helmsley Hotel who read my books and critique them, too! To Arlene Pimentela, you are a fast-reading lady and have a great eye for a story. Thanks for all your advice and love. Millie and Nancy, may God continue to bless you.</p>
<p class="stni">Now to the folks who keep a sister eatin’ and writing. A big, fatty-armed mama hug to all the bookstores and students who supported me during my Northeast tour last year at Howard, Morgan State, and many more. Let’s do it again soon! Valder Beebe of <i>The Valder Beebe Radio Show,</i> thank you for being the perfect host and for bringing your audience the profound message of family I am working hard to instill. Wendy Williams of <i>The Wendy Williams Experience,</i> I thank you with much love for bringing my books to a wider audience. I had much fun on the show! To Karen Hunter and the team at WWRL-AM, thank you for your interest in my work and message. Nancey Flowers, girl, you just got a good heart. Thanks for the love. Zane, thanks for being a wonderful vessel of advice in this business of publishing. You have my respect hands-down for the mark you’ve made.</p>
<p class="stni">And last but not least, thank you, God, for another blessing.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// acknowledgments.vue?9e123fba